<template>
    <div class="row">
        <div class="col-12">
            <div class="row">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="card-header-2">
                                <h5>Product Information</h5>
                            </div>

                            <v-form class="theme-form theme-form-2 mega-form" ref="formProduct" enctype="multipart/form-data">
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Name</label>
                                        <div class="col-sm-10">
                                            <v-card>
                                                <v-tabs v-model="tabLanguageName" color="deep-purple-accent-4">
                                                    <v-tab value="nameEn">Ingles</v-tab>
                                                    <v-tab value="nameEs">Español</v-tab>
                                                    <v-tab value="nameFr">Frances</v-tab>
                                                </v-tabs>
                                                <v-window v-model="tabLanguageName">
                                                    <v-text-field v-if="tabLanguageName === 'nameEn'"
                                                        placeholder="Name ingles" v-model="nameEn" :rules="[(v) => !!v || 'Item is required']"> </v-text-field>
                                                    <v-text-field v-if="tabLanguageName === 'nameEs'"
                                                        placeholder="Nombre español" v-model="nameEs" :rules="[(v) => !!v || 'Item is required']"> </v-text-field>
                                                    <v-text-field v-if="tabLanguageName === 'nameFr'"
                                                        placeholder="Nom français" v-model="nameFr" :rules="[(v) => !!v || 'Item is required']"> </v-text-field>
                                                </v-window>
                                            </v-card>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12">
                                        <div class="row">
                                            <label class="form-label-title col-sm-2 mb-0">Description</label>
                                            <div class="col-sm-10">
                                                <v-card>
                                                    <v-tabs v-model="tabLanguageEditor" color="deep-purple-accent-4">
                                                        <v-tab value="editorDataEn">Ingles</v-tab>
                                                        <v-tab value="editorDataEs">Español</v-tab>
                                                        <v-tab value="editorDataFr">Frances</v-tab>
                                                    </v-tabs>
                                                    <v-window v-model="tabLanguageEditor">
                                                        <div id="editor">
                                                            <ckeditor v-if="tabLanguageEditor === 'editorDataEn'"
                                                                id="snippet-classic-editor-en"
                                                                :editor="editor"
                                                                v-model="editorDataEn"
                                                                :config="editorConfig"
                                                            ></ckeditor>
                                                            <ckeditor v-else-if="tabLanguageEditor === 'editorDataEs'"
                                                                id="snippet-classic-editor-es"
                                                                :editor="editor"
                                                                v-model="editorDataEs"
                                                                :config="editorConfig"
                                                            ></ckeditor>
                                                            <ckeditor v-else-if="tabLanguageEditor === 'editorDataFr'"
                                                                id="snippet-classic-editor-fr"
                                                                :editor="editor"
                                                                v-model="editorDataFr"
                                                                :config="editorConfig"
                                                            ></ckeditor>
                                                        </div>
                                                    </v-window>
                                                </v-card>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                 <br /><br />
                                  <!--  
                                <div class="row">
                                    <div class="col-12">
                                        <div class="mb-4 row align-items-center">
                                            <label class="col-sm-2 col-form-label form-label-title">New Image</label>
                                            <div class="col-sm-10">
                                                <v-file-input v-model="newImage" counter placeholder="Select your image" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="mb-4 row align-items-center">
                                            <label class="col-sm-2 col-form-label form-label-title">Image</label>
                                            <div class="col-sm-10">
                                                <v-img :src="srcImage"></v-img>
                                            </div>
                                        </div>
                                    </div>
                                </div> -->
                                
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">SKU</label>
                                        <div class="col-sm-10">
                                            <v-text-field placeholder="SKU" :model-value="sku" readonly></v-text-field>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Sale price (USD)</label>
                                        <div class="col-sm-10">
                                            <v-text-field placeholder="Sale price (USD)" v-model="salePrice" type="number"></v-text-field>
                                        </div>
                                    </div>
                                </div>
                               
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Discount</label>
                                        <div class="col-sm-10">
                                            <v-text-field placeholder="Discount" v-model="discount" type="number"></v-text-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Offer price (USD)</label>
                                        <div class="col-sm-10">
                                            <v-text-field placeholder="Offer price (USD)" v-model="offerPrice" type="number"></v-text-field>
                                        </div>
                                    </div>
                                </div>
                                <v-expansion-panels>
                                    <v-expansion-panel title="Categorys" color="deep-purple-accent-4">
                                        <v-expansion-panel-text>
                                            <div class="row">
                                                <div class="mb-4 row align-items-center">
                                                    <label class="form-label-title col-sm-2 mb-0">Category</label>
                                                    <div class="col-sm-10" >
                                                        <!--  v-model:selected="selectedTreeCategoryData"
                                                                selectable - mas de uno

                                                                v-model:activated="selectedTreeCategoryData"
                                                                @update:active="getActiveCategoryValue"

                                                                
                                                                
                                                            
                                                                item-text="name" 
                                                        -->
                                                            <!-- name es JSON {es,en,fr}: título formateado -->
                                                            <v-treeview style="max-height:33rem;" class="border"
                                                                :items="treeCategoryData"
                                                                :item-title="(item) => getMultilangText(item.name)"
                                                                item-value="id"
                                                                v-model:activated="selectedTreeCategoryData"
                                                                @update:active="getActiveCategoryValue"
                                                                :open="openedCategoryFather"
                                                                activatable
                                                                open-all
                                                            ></v-treeview>
                                                            <br></br>
                                                            <label class="form-label-title col-sm-10 mb-0">
                                                                Category selected: {{ getSelectedCategoryParents() }}
                                                            </label>
                                                    </div>
                                                                                    
                                                </div>
                                            </div>
                                        </v-expansion-panel-text>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                                <br></br>
                                <v-expansion-panels>
                                    <v-expansion-panel title="Multimedia (AutoSave Order)" color="deep-purple-accent-4">
                                        <v-expansion-panel-text>
                                            <div class="dropzone position-relative d-flex flex-wrap flex-row h-80 overflow-y-auto gap-2 p-2" :class="{ 'dropzone-disabled': uploadingMultimedia }" style="height: 33rem;" @dragover="dragOver" @dragleave="dragLeave" @drop="drop">
                                                <div v-if="uploadingMultimedia" class="dropzone-overlay">
                                                    <v-progress-circular indeterminate color="white" size="40" width="4"></v-progress-circular>
                                                    <div class="mt-2">Subiendo... {{ uploadProgress }}%</div>
                                                </div>
                                                <input class="d-none" type="file" ref="fileInput" id="fileInput" @change="handleFileInput" accept="image/*, video/*" multiple :disabled="uploadingMultimedia">
                                                <!-- <label for="fileInput" class="file-input-button flex justify-center items-center text-center text-sm cursor-pointer border shadow text-slate-400 p-3 h-[48%] w-[48%]"> -->
                                                <label for="fileInput" class="theme-form image-preview cursor-pointer border shadow overflow-hidden flex flex-col justify-center h-full">
                                                    <div class="flex flex-col items-center">
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                                            <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
                                                        </svg>
                                                        <div class="text-center">
                                                            Arrastrar o seleccionar imágenes
                                                        </div>
                                                    </div>
                                                </label>
                                                <!-- <template v-for="(file, index) in files" :key="index">
                                                    <div class="image-preview border overflow-hidden">
                                                        <div class="border flex items-center h-full overflow-hidden">
                                                            <img :src="file.url" :alt="file.name" class="object-fit-cover" style="width: 100%;">
                                                        </div>
                                                        
                                                    </div>
                                                </template> -->                                        
                                        
                                                <template v-for="(file, index) in multimedia" :key="file.id ? 'm-' + file.id : 'new-' + index + '-' + file.name">
                                                    <div class="image-preview border overflow-hidden">
                                                        <div class="position-relative border flex items-center h-full overflow-hidden" style="min-height: 140px;">
                                                            <button v-if="file.isFrontImage === true"  type="button" class="buttons-image-dropzone isMainImage-button">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                                    <path d="M5.52 19c.64-2.2 1.84-3 3.22-3h6.52c1.38 0 2.58.8 3.22 3"/>
                                                                    <circle cx="12" cy="10" r="3"/><circle cx="12" cy="12" r="10"/>
                                                                </svg> 
                                                            </button>
                                                            <button v-if="file.isBackImage === true"  type="button" class="buttons-image-dropzone isBackImage-button">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle>
                                                                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                                                                </svg>
                                                            </button>
                                                            <button v-on:click="deleteThisImage(index, file.id)" :disabled="!file.id" type="button" class="buttons-image-dropzone delete-button">
                                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                                                                    <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                                                                </svg>
                                                            </button>
                                                            <button v-on:click="moveImage(index, file.id, 'left')" :disabled="!file.id" type="button" class="buttons-image-dropzone left-button">
                                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                                                    <path stroke-linecap="round" stroke-linejoin="round" d="m18.75 4.5-7.5 7.5 7.5 7.5m-6-15L5.25 12l7.5 7.5" />
                                                                </svg>
                                                            </button>
                                                            <button v-on:click="moveImage(index, file.id, 'right')" :disabled="!file.id" type="button" class="buttons-image-dropzone right-button">
                                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                                                    <path stroke-linecap="round" stroke-linejoin="round" d="m5.25 4.5 7.5 7.5-7.5 7.5m6-15 7.5 7.5-7.5 7.5" />
                                                                </svg>
                                                            </button>
                                                            <button v-on:click="openDialogUpdateImageProperties(file)" :disabled="!file.id" type="button" class="buttons-image-dropzone edit-image-button">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                                    <path d="M20 14.66V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5.34"></path>
                                                                    <polygon points="18 2 22 6 12 16 8 16 8 12 18 2"></polygon>
                                                                </svg>
                                                            </button>

                                                            <span v-if="file.type === 'video'" class="video-type-badge">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>
                                                                Video
                                                            </span>

                                                            <img v-if="file.type === 'image'" :src="file.codi && file.codi === 'codificada' ? file.url : apiBase+'/assets/multimedia/'+file.name" alt="Imagen del producto" class="object-fit-cover" style="width: 100%;">
                                                            <video
                                                                v-if="file.type === 'video'"
                                                                controls
                                                                class="video-responsive"
                                                                style="width: 100%; height: auto; max-width: 100%;"
                                                                :src="file.codi && file.codi === 'codificada' ? file.url : apiBase+'/assets/multimedia/'+file.name">
                                                                Tu navegador no soporta la reproducción de video.
                                                            </video>

                                                        </div>
                                                    </div>
                                                </template>
                                            </div>

                                            <v-dialog v-model="dialogUpdateImageProperties" max-width="900px">
                                                <v-card :title="updateTypeImageProperties === 'video' ? 'Update video properties' : 'Update image properties'">
                                                    <v-form ref="formUpdateImageProperties">
                                                        <br></br>
                                                        <div style="display:inline;" class="row col-12">
                                                            <div class="row" v-if="updateTypeImageProperties !== 'video'">
                                                                <div class="mb-4 row align-items-center">
                                                                    <div class="row">
                                                                        <div class="col-sm-2">
                                                                            <label class="form-label-title mb-0">Image with color? *</label>
                                                                        </div>
                                                                        <div class="col-sm-3 ">
                                                                            <v-checkbox v-model="enabledColorImageProperties"></v-checkbox>
                                                                        </div>
                                                                        <div class="col-sm-7 form-label-title  mb-0">
                                                                            <v-combobox v-if="enabledColorImageProperties"
                                                                                label="Search color..."
                                                                                :items="dataColorCombo"
                                                                                item-title="name"
                                                                                item-value="id"
                                                                                v-model="updateColorImageProperties"
                                                                                variant="outlined"
                                                                            ></v-combobox>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="mb-4 row align-items-center">
                                                                    <label class="form-label-title col-sm-2 mb-0">{{ updateTypeImageProperties === 'video' ? 'Alt / Descripción (SEO)*' : 'Alt image (SEO)*' }}</label>
                                                                    <div class="col-sm-10">
                                                                        <v-text-field placeholder="Alt image" type="text" v-model="updateAltImageProperties" :rules="[(v) => !!v || 'Item is required']"></v-text-field>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="row mb-4 align-items-center" v-if="updateTypeImageProperties !== 'video'">
                                                                <label class="form-label-title col-sm-2 mb-0 ">Is Front Image(With color)</label>
                                                                <div class="col-sm-4">
                                                                    <v-checkbox v-model="updateIsFrontImageImageProperties" ></v-checkbox>
                                                                </div>
                                                                <label class="form-label-title col-sm-2 mb-0 ">Is Back Image(With color)</label>
                                                                <div class="col-sm-4">
                                                                    <v-checkbox v-model="updateIsBackImageImageProperties" ></v-checkbox>
                                                                </div>
                                                            </div>
                                                            <div class="row mb-4 align-items-center">
                                                                <label class="form-label-title col-sm-2 mb-0 ">Order</label>
                                                                <div class="col-sm-4">
                                                                    <v-text-field placeholder="" type="text" v-model="orderImageProperties" disabled ></v-text-field>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </v-form>
                                                    <v-card-actions>
                                                        <v-spacer></v-spacer>
                                                        <v-btn
                                                            text="Cancel"
                                                            variant="text"
                                                            @click="dialogUpdateImageProperties = false"
                                                        ></v-btn>
                                                        <v-btn
                                                            color="green"
                                                            text="Update"
                                                            variant="flat"
                                                            @click="validateUpdateImageProperties"
                                                        ></v-btn>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-dialog>
                                        </v-expansion-panel-text>
                                    </v-expansion-panel>
                                </v-expansion-panels>

                                <br></br>

                                <v-expansion-panels>
                                    <v-expansion-panel title="Variants (Colors/Sizes)" color="deep-purple-accent-4">
                                        <v-expansion-panel-text>
                                            <v-form class="theme-form theme-form-2 mega-form" ref="formAddArticleColorSize">
                                                <br></br>
                                                <div class="row">
                                                    <div class="mb-6 row align-items-center">
                                                        <div class="row">
                                                            <div class="col-sm-2">
                                                                <label class="form-label-title mb-0">With color? </label>
                                                            </div>
                                                            <div class="col-sm-3 ">
                                                                <v-checkbox v-model="enabledColorVariant"></v-checkbox>
                                                            </div>
                                                            <div class="col-sm-6 form-label-title  mb-0">
                                                                <v-combobox v-if="enabledColorVariant"
                                                                    label="Search color..."
                                                                    :items="dataColorCombo"
                                                                    item-title="name"
                                                                    item-value="id"
                                                                    v-model="colorVariant"
                                                                    variant="outlined"
                                                                ></v-combobox>
                                                            </div>
                                                            <div class="col-sm-1 form-label-title mb-0" readonly v-if="enabledColorVariant"
                                                                :style="{
                                                                    backgroundColor: selectedColorVariantHex,
                                                                    height: '55px', /* Alto del cuadrado */
                                                                    border: '2px solid #000', /* Borde negro */
                                                                    borderRadius: '5px', /* Esquinas ligeramente redondeadas */
                                                                    display: 'flex', /* Centrar el texto dentro del div */
                                                                    alignItems: 'center', /* Centrar verticalmente */
                                                                    justifyContent: 'center' /* Centrar horizontalmente */
                                                                }">
                                                                <span>{{ selectedColorVariantHex }}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class=" mb-4 row align-items-center">
                                                        <div class="row">
                                                            <div class="col-sm-2">
                                                                <label class="form-label-title ">With size? </label>
                                                            </div>
                                                            <div class="col-sm-3 ">
                                                                <v-checkbox v-model="enabledSizeVariant"></v-checkbox>
                                                            </div>
                                                            <div class="col-sm-7 form-label-title  mb-0">
                                                                <v-radio-group inline label="Sizes" v-if="enabledSizeVariant" v-model="sizeVariant" >
                                                                    <v-radio v-for="(size, index) in dataSizeCombo" :key="index" :label="'[' + size.code + '] ' + size.name" :value="size.id" ></v-radio>
                                                                </v-radio-group>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="d-flex flex-column">
                                                    <v-btn class="mt-4" color="success" block @click="validateAddArticleColorSize"> Add variant </v-btn>
                                                </div>
                                                <v-alert v-if="messageErrorVariant != ''" :type="typeOfMessageVariant" :text="messageErrorVariant"></v-alert>
                                            </v-form>
                                            <br></br>
                                            <div class="row">
                                                <div class="col-sm-12">
                                                    <div class="card">
                                                        <div class="card-body">
                                                            <div class="table-responsive table-desi table-product">
                                                                <v-data-table
                                                                    class="table table-1d all-package"
                                                                    :headers="headersVariant"
                                                                    :items="dataArticleColorSizeGrid"
                                                                    :loading="loadingVariant"
                                                                    item-value="id"
                                                                >
                                                                    <template v-slot:item.id="{ item }">
                                                                        <v-chip size="small" color="primary" variant="tonal">ACS #{{ item.id }}</v-chip>
                                                                    </template>
                                                                    <template v-slot:item.color_name="{ item }">
                                                                        <div class="d-flex align-center justify-center" style="gap: 6px;">
                                                                            <span
                                                                                v-if="item.color_hexadecimal"
                                                                                :style="{
                                                                                    backgroundColor: item.color_hexadecimal,
                                                                                    display: 'inline-block',
                                                                                    width: '14px',
                                                                                    height: '14px',
                                                                                    borderRadius: '3px',
                                                                                    border: '1px solid #000'
                                                                                }"
                                                                            ></span>
                                                                            <span>{{ item.color_name || '-' }}</span>
                                                                        </div>
                                                                    </template>
                                                                    <template v-slot:item.size_name="{ item }">
                                                                        {{ item.size_name || '-' }}
                                                                    </template>
                                                                    <template v-slot:item.variant_image="{ item }">
                                                                        <v-img v-if="resolveVariantImageUrl(item.variant_image)" :src="resolveVariantImageUrl(item.variant_image)" class="inventory-variant-thumb my-2 rounded" cover></v-img>
                                                                        <span v-else>-</span>
                                                                    </template>
                                                                    <template v-slot:item.variant_sku="{ item }">
                                                                        {{ item.variant_sku || '-' }}
                                                                    </template>
                                                                    <template v-slot:item.barcode="{ item }">
                                                                        {{ item.barcode || '-' }}
                                                                    </template>
                                                                    <template v-slot:item.variant_weight="{ item }">
                                                                        {{ item.variant_weight ?? '-' }}
                                                                    </template>
                                                                    <template v-slot:item.cjvid="{ item }">
                                                                        <v-chip v-if="item.cjvid" size="small" color="deep-purple-accent-4" variant="tonal" title="Sincronizada con CJ Dropshipping (vid)">
                                                                            CJ
                                                                        </v-chip>
                                                                        <v-chip v-else size="small" color="grey" variant="tonal">
                                                                            Manual
                                                                        </v-chip>
                                                                    </template>
                                                                    <template v-slot:item.stock_total="{ item }">
                                                                        {{ item.stock_total }}
                                                                    </template>
                                                                    <template v-slot:item.inventory_count="{ item }">
                                                                        {{ item.inventory_count }}
                                                                    </template>
                                                                    <template v-slot:item.actions="{ item }">
                                                                        <v-btn color="error" class="elevation-0" icon variant="plain" @click="openDialogDeleteArticleColorSize(item)"><v-icon> mdi-trash-can-outline </v-icon></v-btn>
                                                                    </template>
                                                                </v-data-table>
                                                                <v-alert v-if="messageErrorVariantGrid != ''" :type="typeOfMessageVariantGrid" :text="messageErrorVariantGrid"></v-alert>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <v-dialog v-model="dialogDeleteArticleColorSize" max-width="600px">
                                                <v-card>
                                                    <v-card-title class="confirmation-dialog" primary-title>Confirmation</v-card-title>
                                                    <v-card-text>Are you sure you want to delete the variant 'ACS #{{ itemArticleColorSizeToDelete?.id ?? "N/A" }}'? Only works if it has no inventory rows.</v-card-text>
                                                    <v-card-actions>
                                                        <v-btn color="red" text @click="dialogDeleteArticleColorSize = false">Cancel</v-btn>
                                                        <v-btn color="green" text @click="deleteArticleColorSize()">Delete</v-btn>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-dialog>
                                        </v-expansion-panel-text>
                                    </v-expansion-panel>
                                </v-expansion-panels>

                                <br></br>

                                <v-expansion-panels>
                                    <v-expansion-panel title="Inventory" color="deep-purple-accent-4">
                                        <v-expansion-panel-text>
                                            <v-form class="theme-form theme-form-2 mega-form" ref="formAddInventoryProduct" >
                                                <br></br>
                                                <div class="row">
                                                    <div class="mb-4 row align-items-center">
                                                        <label class="form-label-title col-sm-2 mb-0">Vendor</label>
                                                        <div class="col-sm-10">
                                                            <v-combobox
                                                                label="Search vendor..."
                                                                :items="dataVendorCombo"
                                                                item-title="name"
                                                                item-value="id"
                                                                v-model="vendorInventory"
                                                                variant="outlined"
                                                            ></v-combobox>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="mb-4 row align-items-center">
                                                        <label class="form-label-title col-sm-2 mb-0">Variant</label>
                                                        <div class="col-sm-10">
                                                            <v-combobox
                                                                label="Search variant (color/size)..."
                                                                :items="variantComboItems"
                                                                item-title="label"
                                                                item-value="id"
                                                                v-model="articleColorSizeInventory"
                                                                variant="outlined"
                                                                :rules="[(v) => !!v || 'Selecciona una variante']"
                                                                hint="Crea la variante primero en el panel 'Variants (Colors/Sizes)' de arriba si no aparece en la lista."
                                                                persistent-hint
                                                            ></v-combobox>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="mb-4 row align-items-center">
                                                        <label class="form-label-title col-sm-2 mb-0">Quantity</label>
                                                        <div class="col-sm-10">
                                                            <v-text-field placeholder="Quantity" type="number" v-model="quantityInventory" :rules="[(v) => !!v || 'Item is required']"></v-text-field>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="mb-4 row align-items-center">
                                                        <label class="form-label-title col-sm-2 mb-0">Stock</label>
                                                        <div class="col-sm-10">
                                                            <v-text-field placeholder="Available stock" type="number" v-model="stockInventory"></v-text-field>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="mb-4 row align-items-center">
                                                        <label class="form-label-title col-sm-2 mb-0">Description</label>
                                                        <div class="col-sm-10">
                                                            <v-text-field class="form-label" placeholder="Description inventory" v-model="descriptionInventory"></v-text-field>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="d-flex flex-column">
                                                    <v-btn class="mt-4" color="success" block @click="validateAddInventoryProduct"> Add inventory </v-btn>
                                                </div>
                                                <v-alert v-if="messageErrorInventory != ''" :type="typeOfMessageInventory" :text="messageErrorInventory"></v-alert>
                                            </v-form>
                                            <br></br>
                                            <div class="row">
                                                <div class="col-sm-12">
                                                    <div class="card">
                                                        <div class="card-body">
                                                            <div class="table-responsive table-desi table-product">
                                                                <v-data-table-server
                                                                    class="table table-1d all-package"
                                                                    v-model:items-per-page="itemsPerPage"
                                                                    :search="searchInventoryProductGrid"
                                                                    :headers="showHeaders"
                                                                    :items-length="pagination.total"
                                                                    :items="dataInventoryProductGrid"
                                                                    :loading="loading"
                                                                    item-value="name"
                                                                    @update:options="getInventoryProductGrid"
                                                                >
                                                                    <template v-slot:thead>
                                                                        <tbody>
                                                                            <tr>
                                                                                <td v-if="selectedHeaders.includes('article_color_size_id')"></td>
                                                                                <td v-if="selectedHeaders.includes('vendor_name')">
                                                                                    <v-combobox
                                                                                        label="Search vendor..."
                                                                                        :items="dataVendorCombo"
                                                                                        item-title="name"
                                                                                        item-value="id"
                                                                                        hide-details
                                                                                        class="ma-2"
                                                                                        density="compact"
                                                                                        v-model="filterVendorGridInventory"
                                                                                    ></v-combobox>
                                                                                </td> 
                                                                                <td v-if="selectedHeaders.includes('color_name')">
                                                                                    <v-combobox
                                                                                        label="Search color..."
                                                                                        :items="dataColorCombo"
                                                                                        item-title="name"
                                                                                        item-value="id"
                                                                                        hide-details
                                                                                        class="ma-2"
                                                                                        density="compact"
                                                                                        v-model="filterColorGridInventory"
                                                                                    ></v-combobox>
                                                                                </td> 
                                                                                <td v-if="selectedHeaders.includes('size_name')">
                                                                                    <v-combobox
                                                                                        label="Search size..."
                                                                                        :items="dataSizeCombo"
                                                                                        item-title="name"
                                                                                        item-value="id"
                                                                                        hide-details
                                                                                        class="ma-2"
                                                                                        density="compact"
                                                                                        v-model="filterSizeGridInventory"
                                                                                    ></v-combobox>
                                                                                </td>
                                                                                <td v-if="selectedHeaders.includes('variant_image')"></td>
                                                                                <td v-if="selectedHeaders.includes('quantity')">
                                                                                    <v-text-field v-model="filterQuantityGridInventory" hide-details placeholder="Search quantity..." class="ma-2" density="compact"></v-text-field>
                                                                                </td>
                                                                                <td v-if="selectedHeaders.includes('stock')">
                                                                                    <v-text-field v-model="filterStockGridInventory" hide-details placeholder="Search stock..." class="ma-2" density="compact"></v-text-field>
                                                                                </td>
                                                                                <td v-if="selectedHeaders.includes('description')">
                                                                                    <v-text-field v-model="filterDescriptionGridInventory" hide-details placeholder="Search description..." class="ma-2" density="compact"></v-text-field>
                                                                                </td>

                                                                                <td v-if="selectedHeaders.includes('actions')"></td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </template>

                                                                    <template v-slot:item.article_color_size_id="{ item }">
                                                                        <v-chip v-if="item.article_color_size_id" size="small" color="primary" variant="tonal">
                                                                            ACS #{{ item.article_color_size_id }}
                                                                        </v-chip>
                                                                        <span v-else>-</span>
                                                                    </template>
                                                                    <template v-slot:item.color_name="{ item }">
                                                                        <div class="d-flex align-center justify-center" style="gap: 6px;">
                                                                            <span
                                                                                v-if="item.color_hexadecimal"
                                                                                :style="{
                                                                                    backgroundColor: item.color_hexadecimal,
                                                                                    display: 'inline-block',
                                                                                    width: '14px',
                                                                                    height: '14px',
                                                                                    borderRadius: '3px',
                                                                                    border: '1px solid #000'
                                                                                }"
                                                                            ></span>
                                                                            <span>{{ item.color_name || '-' }}</span>
                                                                        </div>
                                                                    </template>
                                                                    <template v-slot:item.variant_image="{ item }">
                                                                        <v-img
                                                                            v-if="getInventoryVariantImage(item)"
                                                                            :src="getInventoryVariantImage(item)"
                                                                            class="inventory-variant-thumb my-2 rounded"
                                                                            cover
                                                                        ></v-img>
                                                                        <span v-else>-</span>
                                                                    </template>
                                                                    <template v-slot:item.actions="{ item }">
                                                                        <v-btn color="primary" class="elevation-0" icon variant="plain" @click="openDialogUpdateGridInventory(item)"> <v-icon> mdi-pencil-outline </v-icon> </v-btn>
                                             
                                                                        <v-dialog v-model="dialogEditGridInventory" max-width="1000px">
                                    
                                                                            <v-card title="Update inventory">
                                                                            
                                                                                <v-form ref="formUpdateProductInventory">
                                                                                    <br></br>
                                                                                    <div style="display:inline;" class="row col-12">
                                                                                        <div class="row">
                                                                                            <div class="mb-4 row align-items-center">
                                                                                                <label class="form-label-title col-sm-2 mb-0">Vendor</label>
                                                                                                <div class="col-sm-10">
                                                                                                    <v-combobox
                                                                                                        label="Search vendor..."
                                                                                                        :items="dataVendorCombo"
                                                                                                        item-title="name"
                                                                                                        item-value="id"
                                                                                                        v-model="updateVendorArticleInventory"
                                                                                                        variant="outlined"
                                                                                                    ></v-combobox>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        
                                                                                        <div class="row">
                                                                                            <div class="mb-4 row align-items-center">
                                                                                                <label class="form-label-title col-sm-2 mb-0">Variant</label>
                                                                                                <div class="col-sm-10 d-flex align-center" style="gap: 8px;">
                                                                                                    <v-chip v-if="updateArticlecolorsizeidArticleInventory" size="small" color="primary" variant="tonal">
                                                                                                        ACS #{{ updateArticlecolorsizeidArticleInventory }}
                                                                                                    </v-chip>
                                                                                                    <span
                                                                                                        v-if="updateColorArticleInventory && updateColorArticleInventory.hexadecimalCode"
                                                                                                        :style="{
                                                                                                            backgroundColor: updateColorArticleInventory.hexadecimalCode,
                                                                                                            display: 'inline-block',
                                                                                                            width: '16px',
                                                                                                            height: '16px',
                                                                                                            borderRadius: '3px',
                                                                                                            border: '1px solid #000'
                                                                                                        }"
                                                                                                    ></span>
                                                                                                    <span>{{ updateColorArticleInventory && updateColorArticleInventory.name ? updateColorArticleInventory.name : '-' }} / {{ updateSizeArticleInventory && updateSizeArticleInventory.name ? updateSizeArticleInventory.name : '-' }}</span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>

                                                                                        <div class="row">
                                                                                            <div class="mb-4 row align-items-center">
                                                                                                <label class="form-label-title col-sm-2 mb-0">Quantity</label>
                                                                                                <div class="col-sm-10">
                                                                                                    <v-text-field placeholder="Quantity" type="number" v-model="updateQuantityArticleInventory" :rules="[(v) => !!v || 'Item is required']"></v-text-field>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="row">
                                                                                            <div class="mb-4 row align-items-center">
                                                                                                <label class="form-label-title col-sm-2 mb-0">Stock</label>
                                                                                                <div class="col-sm-10">
                                                                                                    <v-text-field placeholder="Available stock" type="number" v-model="updateStockArticleInventory" :rules="[(v) => !!v || 'Item is required']"></v-text-field>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="row">
                                                                                            <div class="mb-4 row align-items-center">
                                                                                                <label class="form-label-title col-sm-2 mb-0">Description</label>
                                                                                                <div class="col-sm-10">
                                                                                                    <v-text-field placeholder="Description inventory" v-model="updateDescriptionArticleInventory"></v-text-field>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </v-form>

                                                                                <v-card-actions>
                                                                                    <v-spacer></v-spacer>

                                                                                    <v-btn
                                                                                        text="Cancel"
                                                                                        variant="text"
                                                                                        @click="dialogEditGridInventory = false"
                                                                                    ></v-btn>
                                                                                    <v-btn
                                                                                        color="green"
                                                                                        text="Update"
                                                                                        variant="flat"
                                                                                        @click="validateUpdateProductInventory"
                                                                                        
                                                                                    ></v-btn>
                                                                                </v-card-actions>
                                                                            </v-card>
                                                                            
                                                                        </v-dialog>


                                                                        <v-btn color="error"   class="elevation-0" icon variant="plain" @click="openDialogDeleteGridInventory(item)"><v-icon> mdi-trash-can-outline </v-icon> </v-btn>
                                            
                                                                        <v-dialog v-model="dialogDeleteGridInventory" max-width="600px">
                                                                            <v-card>
                                                                                <v-card-title class="confirmation-dialog" primary-title>Confirmation</v-card-title>
                                                                                <v-card-text>  Are you sure you want to delete the inventory with the stock '{{ itemInventoryToDelete?.stock ?? "N/A" }}'? </v-card-text>
                                                                                <v-card-actions>
                                                                                    <v-btn color="red"   text @click="dialogDeleteGridInventory = false">Cancel</v-btn>
                                                                                    <v-btn color="green" text @click="deleteProductInventory()">Delete</v-btn>
                                                                                </v-card-actions>
                                                                            </v-card>
                                                                        </v-dialog>
                                                                    </template>
                                                                </v-data-table-server>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </v-expansion-panel-text>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                                <br></br>

                                <v-expansion-panels>
                                    <v-expansion-panel title="Comments by product" color="deep-purple-accent-4">
                                        <v-expansion-panel-text>
                                            <div class="row">
                                                <div class="col-sm-12">
                                                    <div class="card">
                                                        <div class="card-body">
                                                            <v-card variant="outlined" class="new-comment-form mb-4">
                                                                <v-card-item>
                                                                    <template v-slot:prepend>
                                                                        <v-icon color="deep-purple-accent-4">mdi-comment-plus-outline</v-icon>
                                                                    </template>
                                                                    <v-card-title class="text-subtitle-1">Add comment</v-card-title>
                                                                    <v-card-subtitle>Se publica de inmediato con estado "Aprobado".</v-card-subtitle>
                                                                </v-card-item>
                                                                <v-card-text>
                                                                    <v-textarea
                                                                        v-model="newCommentText"
                                                                        label="Comment"
                                                                        variant="outlined"
                                                                        rows="3"
                                                                        auto-grow
                                                                        hide-details
                                                                        class="mb-4"
                                                                    ></v-textarea>

                                                                    <div class="d-flex align-center mb-4" style="gap: 12px;">
                                                                        <span class="form-label-title mb-0">Assessment</span>
                                                                        <v-rating
                                                                            v-model="newCommentAssessment"
                                                                            color="orange-darken-2"
                                                                            density="compact"
                                                                        ></v-rating>
                                                                    </div>

                                                                    <div class="row">
                                                                        <div class="col-sm-6">
                                                                            <v-file-input
                                                                                v-model="newCommentImages"
                                                                                label="Images (max 5, 8 MB each)"
                                                                                variant="outlined"
                                                                                density="comfortable"
                                                                                multiple
                                                                                chips
                                                                                counter
                                                                                accept="image/*"
                                                                                prepend-icon=""
                                                                                prepend-inner-icon="mdi-image-multiple"
                                                                                hide-details
                                                                            ></v-file-input>
                                                                        </div>
                                                                        <div class="col-sm-6">
                                                                            <v-file-input
                                                                                v-model="newCommentVideos"
                                                                                label="Videos (max 2, 25 MB each)"
                                                                                variant="outlined"
                                                                                density="comfortable"
                                                                                multiple
                                                                                chips
                                                                                counter
                                                                                accept="video/*"
                                                                                prepend-icon=""
                                                                                prepend-inner-icon="mdi-video"
                                                                                hide-details
                                                                            ></v-file-input>
                                                                        </div>
                                                                    </div>

                                                                    <v-alert v-if="newCommentError" type="error" density="compact" variant="tonal" class="mt-4">{{ newCommentError }}</v-alert>
                                                                </v-card-text>
                                                                <v-card-actions>
                                                                    <v-spacer></v-spacer>
                                                                    <v-btn
                                                                        color="primary"
                                                                        prepend-icon="mdi-plus"
                                                                        :loading="savingNewComment"
                                                                        @click="createProductComment"
                                                                    >
                                                                        Add comment
                                                                    </v-btn>
                                                                </v-card-actions>
                                                            </v-card>
                                                            <div class="table-responsive table-desi table-product">
                                                                <v-data-table-server
                                                                    class="table table-1d all-package blogGrid"
                                                                    v-model:items-per-page="itemsPerPageComments"
                                                                    :search="searchCommentsProductGrid"
                                                                    :headers="showHeadersComments"
                                                                    :items-length="paginationComments.total"
                                                                    :items="dataCommentsProductGrid"
                                                                    :loading="loadingComments"
                                                                    item-value="id"
                                                                    @update:options="getProductCommentsGrid"
                                                                >
                                                                    <template v-slot:thead>
                                                                        <tbody>
                                                                            <tr>
                                                                                <td v-if="selectedHeadersComments.includes('user_name')">
                                                                                    <v-text-field v-model="filterUserNameComment" hide-details placeholder="Search user..." class="ma-2" density="compact"></v-text-field>
                                                                                </td>
                                                                                <td v-if="selectedHeadersComments.includes('comment')">
                                                                                    <v-text-field v-model="filterTextComment" hide-details placeholder="Search comment..." class="ma-2" density="compact"></v-text-field>
                                                                                </td>
                                                                                <td v-if="selectedHeadersComments.includes('assessment')">
                                                                                    <v-rating
                                                                                        v-model="filterAssessmentComment"
                                                                                        color="orange-darken-2"
                                                                                        density="compact"
                                                                                        background-color="grey-lighten-2"
                                                                                    ></v-rating>
                                                                                </td>
                                                                                <td v-if="selectedHeadersComments.includes('updated_at')">
                                                                                    <v-text-field v-model="filterUpdatedAtComment" hide-details placeholder="Search updated at..." class="ma-2" density="compact"></v-text-field>
                                                                                </td>
                                                                                <td v-if="selectedHeadersComments.includes('has_media')"></td>
                                                                                <td v-if="selectedHeadersComments.includes('status_name')"></td>
                                                                                <td v-if="selectedHeadersComments.includes('actions')"></td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </template>

                                                                    <template v-slot:item.assessment="{ item }">
                                                                        <v-rating
                                                                            v-model="item.assessment"
                                                                            color="orange-darken-2"
                                                                            density="compact"
                                                                            size="small"
                                                                            readonly
                                                                        ></v-rating>
                                                                    </template>

                                                                    <template v-slot:item.updated_at="{ item }">
                                                                        <span>{{ getFormatUpdatedAtComment(item.updated_at) }}</span>
                                                                    </template>

                                                                    <template v-slot:item.has_media="{ item }">
                                                                        <v-icon v-if="item.media_count > 0" color="success">mdi-paperclip</v-icon>
                                                                        <v-icon v-else color="grey">mdi-minus</v-icon>
                                                                    </template>

                                                                    <template v-slot:item.status_name="{ item }">
                                                                        <article-comment-status-component
                                                                            :items="itemsArticleCommentStatus"
                                                                            :selected="getSelectedArticleCommentStatus(item)"
                                                                            :selectedItem="item"
                                                                            :saving="isStatusSavingComment(item)"
                                                                            :saved="isStatusSavedComment(item)"
                                                                            :showSaveButton="true"
                                                                            @update:selected="(value) => handleArticleCommentStatusChange(value, item)"
                                                                            @save:selected="(value) => handleArticleCommentStatusChange(value, item)"
                                                                        />
                                                                    </template>

                                                                    <template v-slot:item.actions="{ item }">
                                                                        <v-btn color="success" class="elevation-0" icon variant="plain" @click="editProductComment(item)"><v-icon>mdi-text-box-edit-outline</v-icon></v-btn>
                                                                        <v-btn color="error" class="elevation-0" icon variant="plain" @click="openDialogDeleteComment(item)"><v-icon>mdi-trash-can-outline</v-icon></v-btn>
                                                                    </template>
                                                                </v-data-table-server>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </v-expansion-panel-text>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                                <br></br>

                                <div class="row">
                                    <div class="col-12 blogGrid">
                                        <div class="mb-4 row align-items-center">
                                            <label class="col-sm-2 col-form-label form-label-title">Is new</label>
                                            <div class="col-sm-10">
                                                <v-checkbox v-model="isNew" label="Is new"></v-checkbox>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12">
                                        <div class="mb-4 row align-items-center">
                                            <label class="col-sm-2 col-form-label form-label-title">Active</label>
                                            <div class="col-sm-10">
                                                <v-checkbox v-model="active" label="Active"></v-checkbox>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            
                                <div class="d-flex flex-column">
                                    <v-btn class="mt-4" color="success" block @click="validate"> Update </v-btn>
                                </div>
                            </v-form>
                        </div>

                        <v-alert v-if="messageError != ''" :type="typeOfMessage" :text="messageError"></v-alert>
                            <v-dialog v-model="dialogDeleteProductComment" max-width="600px">
                                <v-card>
                                    <v-card-title class="confirmation-dialog" primary-title>Confirmation</v-card-title>
                                    <v-card-text> Are you sure you want to delete the comment '{{ itemProductCommentToDelete?.comment ?? "" }}'? </v-card-text>
                                    <v-card-actions>
                                        <v-btn color="red" text @click="dialogDeleteProductComment = false">Cancel</v-btn>
                                        <v-btn color="green" text @click="deleteProductComment()">Delete</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import axios from 'axios'
import { getMultilangText } from '@/services/multilangText'
import { ref, onMounted } from 'vue'
import { mapGetters } from 'vuex'
import _ from 'lodash';
import ArticleCommentStatusComponent from '@/components/article_comments/articleCommentStatusComponent.vue'
import {
    getArticleCommmentsStatusListService,
    getGridArticleCommentService,
    articleCommmentsStatusChangeService,
    deleteArticleCommentService,
    createArticleCommentService
} from '@/services/ArticleCommentService'

   
export default {
    name: 'app',
    title: 'Edit Product',
    components: {
        ArticleCommentStatusComponent
    },
    data() {
        return {
            apiBase: process.env.VUE_APP_URL_API_BASE,
            id: null,
            author: null,
            
            tabLanguageName: null,
            nameEn: '',
            nameEs: '',
            nameFr: '',

            tabLanguageEditor: null,
            editorDataEn: '',
            editorDataEs: '',
            editorDataFr: '',

            salePrice: '',
            discount: '',
            offerPrice: '',
            sku: '',

            editor: ClassicEditor,
            editorConfig: {
                toolbar: {
                    items: ['undo', 'redo', '|', 'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote']
                },
                language: 'es'
            },
            newImage: [],
            srcImage: null,
            altImage: null,

            // Estado de subida de multimedia (spinner del dropzone)
            uploadingMultimedia: false,
            uploadProgress: 0,

            //VARIANTES (ArticleColorSize)

            enabledColorVariant: false,
            colorVariant: '',
            enabledSizeVariant: false,
            sizeVariant: '',
            dataColorCombo: [],
            dataSizeCombo: [],
            dataArticleColorSizeGrid: ref([]),
            loadingVariant: false,
            messageErrorVariant: '',
            typeOfMessageVariant: '',
            messageErrorVariantGrid: '',
            typeOfMessageVariantGrid: '',
            dialogDeleteArticleColorSize: false,
            itemArticleColorSizeToDelete: null,
            headersVariant: [
                { title: 'ID', align: 'start', sortable: false, key: 'id' },
                { title: 'Color', align: 'center', sortable: false, key: 'color_name' },
                { title: 'Size', align: 'center', sortable: false, key: 'size_name' },
                { title: 'Image', align: 'center', sortable: false, key: 'variant_image' },
                { title: 'Variant SKU', align: 'center', sortable: false, key: 'variant_sku' },
                { title: 'Barcode', align: 'center', sortable: false, key: 'barcode' },
                { title: 'Weight (g)', align: 'center', sortable: false, key: 'variant_weight' },
                { title: 'Source', align: 'center', sortable: false, key: 'cjvid' },
                { title: 'Stock total', align: 'center', sortable: false, key: 'stock_total' },
                { title: 'Inventory rows', align: 'center', sortable: false, key: 'inventory_count' },
                { title: 'Actions', align: 'center', sortable: false, key: 'actions' }
            ],

            //INVENTARIO

            dataVendorCombo: [],
            vendorInventory: '',
            articleColorSizeInventory: '',
            quantityInventory: '',
            stockInventory: '',
            descriptionInventory: '',


            //INVENTARIO GRID
            dataInventoryProductGrid: ref([]),
            pagination: ref({
                from: 0,
                to: 0,
                total: 0,
                current: 1,
                lastPage: 0
            }),
            itemsPerPage: 10,

            selectedHeaders: ['article_color_size_id', 'vendor_name', 'color_name', 'size_name', 'variant_image', 'quantity', 'stock', 'description', 'actions'],
            headers: [
                {
                    title: 'ID',
                    align: 'start',
                    sortable: true,
                    key: 'id'
                },
                {
                    title: 'Variant (ArticleColorSize)',
                    align: 'center',
                    sortable: true,
                    key: 'article_color_size_id',
                    value: 'article_color_size_id'
                },
                 {
                    title: 'Vendor',
                    align: 'center',
                    sortable: true,
                    key: 'vendor_name',
                    value: 'vendor_name'
                }, 
                {
                    title: 'Color',
                    align: 'center',
                    sortable: true,
                    key: 'color_name',
                    value: 'color_name'
                },
                {
                    title: 'Size',
                    align: 'center',
                    sortable: true,
                    key: 'size_name',
                    value: 'size_name'
                },
                {
                    title: 'Image',
                    align: 'center',
                    sortable: false,
                    key: 'variant_image',
                    value: 'variant_image'
                },
                {
                    title: 'Quantity',
                    align: 'center',
                    sortable: true,
                    key: 'quantity',
                    value: 'quantity'
                },
                {
                    title: 'Stock',
                    align: 'center',
                    sortable: true,
                    key: 'stock',
                    value: 'stock'
                },
                {
                    title: 'Description',
                    align: 'center',
                    sortable: true,
                    key: 'description',
                    value: 'description'
                },
                {
                    title: 'Actions',
                    align: 'center',
                    sortable: false,
                    key: 'actions'
                }
            ],
            loading: true,

            // Edicion de imagenes
            dialogUpdateImageProperties: false,

            updateIdImageProperties: '',
            updateTypeImageProperties: '',
            enabledColorImageProperties: false,
            updateColorImageProperties: '',
            updateAltImageProperties  : '',
            updateIsFrontImageImageProperties: false,
            updateIsBackImageImageProperties: false,
            isMainImageProperties: false,
            orderImageProperties: '',

            // Filtros grid inventory - search
            searchInventoryProductGrid: '',
            idGridInventory: '',
            filterVendorGridInventory: '',
            filterColorGridInventory: '',
            filterSizeGridInventory: '',
            filterQuantityGridInventory: '',
            filterStockGridInventory: '',
            filterDescriptionGridInventory: '',

            // Update/Delete Inventario
            dialogDeleteGridInventory: false,
            dialogEditGridInventory: false,

            updateIdInventoryArticleInventory: '',
            updateArticlecolorsizeidArticleInventory: '',
            updateVendorArticleInventory: '',
            updateColorArticleInventory: '',
            updateSizeArticleInventory: '',
            updateQuantityArticleInventory: '',
            updateStockArticleInventory: '',
            updateDescriptionArticleInventory: '',

            itemInventoryToDelete: null,

            // COMMENTS GRID (BY PRODUCT)
            itemsArticleCommentStatus: [],
            dataCommentsProductGrid: ref([]),
            paginationComments: ref({
                from: 0,
                to: 0,
                total: 0,
                current: 1,
                lastPage: 0
            }),
            itemsPerPageComments: 10,
            selectedHeadersComments: ['user_name', 'comment', 'assessment', 'updated_at', 'has_media', 'status_name', 'actions'],
            headersComments: [
                {
                    title: 'User',
                    align: 'center',
                    sortable: true,
                    key: 'user_name'
                },
                {
                    title: 'Comment',
                    align: 'center',
                    sortable: true,
                    key: 'comment'
                },
                {
                    title: 'Assessment',
                    align: 'center',
                    sortable: true,
                    key: 'assessment'
                },
                {
                    title: 'Updated at',
                    align: 'center',
                    sortable: true,
                    key: 'updated_at'
                },
                {
                    title: 'Attached',
                    align: 'center',
                    sortable: false,
                    key: 'has_media'
                },
                {
                    title: 'Status',
                    align: 'center',
                    sortable: false,
                    key: 'status_name'
                },
                {
                    title: 'Actions',
                    align: 'center',
                    sortable: false,
                    key: 'actions'
                }
            ],
            loadingComments: false,
            searchCommentsProductGrid: '',
            filterUserNameComment: '',
            filterTextComment: '',
            filterAssessmentComment: 0,
            filterUpdatedAtComment: '',
            dialogDeleteProductComment: false,
            itemProductCommentToDelete: null,
            statusSavingCommentsById: {},
            statusSavedCommentsById: {},
            newCommentText: '',
            newCommentAssessment: 0,
            newCommentImages: [],
            newCommentVideos: [],
            newCommentError: '',
            savingNewComment: false,

            // Categoria
            selectedTreeCategoryData  : [], 
            treeCategoryData : [],   
            openedCategoryFather: [0,1],
                       
            isNew: false,
            active: false,

            messageErrorInventory: '',
            typeOfMessageInventory: '',

            messageError: '',
            typeOfMessage: '',

            // Dropzone 
            files: [],
            multimedia: [
                /* {
                    id: "",
                    name: ""
                } */
            ],
            selectedImages: [],
        }
    },
    watch: {
        loading() {

        },
        editorData() {
        },
        newImage() {
        },
        quantityInventory(value) {
            this.stockInventory = value;
        },
        discount(value) {
            // Asegurarse de que salePrice y value tengan valores
            if (this.salePrice !== '' && value !== '') {
                // Convertir salePrice a número si es un string
                const salePrice = parseFloat(this.salePrice);
                // Calcular el precio con descuento
                this.offerPrice = salePrice * (1 - value / 100);
                this.offerPrice = this.offerPrice.toFixed(2);
            }
        },
        id() {
            this.search = String(Date.now())
        },
        filterVendorGridInventory() {
            this.searchInventoryProductGrid = String(Date.now())
        },
        filterColorGridInventory() {
            this.searchInventoryProductGrid = String(Date.now())
        },
        filterSizeGridInventory() {
            this.searchInventoryProductGrid = String(Date.now())
        },
        filterQuantityGridInventory() {
            this.searchInventoryProductGrid = String(Date.now())
        },
        filterStockGridInventory() {
            this.searchInventoryProductGrid = String(Date.now())
        },
        filterDescriptionGridInventory() {
            this.searchInventoryProductGrid = String(Date.now())
        },
        filterUserNameComment() {
            this.searchCommentsProductGrid = String(Date.now())
        },
        filterTextComment() {
            this.searchCommentsProductGrid = String(Date.now())
        },
        filterAssessmentComment() {
            this.searchCommentsProductGrid = String(Date.now())
        },
        filterUpdatedAtComment() {
            this.searchCommentsProductGrid = String(Date.now())
        },
        
    },
    computed: {
        //Done to get the ordered headers
        showHeaders() {
            return this.headers.filter((s) => this.selectedHeaders.includes(s.key))
        },
        showHeadersComments() {
            return this.headersComments.filter((s) => this.selectedHeadersComments.includes(s.key))
        },
        ...mapGetters({
            getUser: 'getUser'
        }),  
        selectedColorVariantHex() {
            // Encuentra el color seleccionado en la lista de colores
            const selectedColorVariantHex = this.dataColorCombo.find(color => color === this.colorVariant);
            // Retorna el código hexadecimal si se encuentra, de lo contrario, retorna un string vacío
            return selectedColorVariantHex ? selectedColorVariantHex.hexadecimalCode : '';
        },
        // Variantes (ArticleColorSize) del articulo, listas para el combobox del panel Inventory
        variantComboItems() {
            return this.dataArticleColorSizeGrid.map((variant) => ({
                id: variant.id,
                label: `ACS #${variant.id} — ${variant.color_name || 'Sin color'} / ${variant.size_name || 'Sin talla'}`
            }))
        }

    },
    methods: {
        getMultilangText,
        resolveVariantImageUrl(rawVariantImage) {
            const trimmed = String(rawVariantImage || '').trim();
            if (!trimmed) {
                return '';
            }
            if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
                return trimmed;
            }

            const base = String(this.apiBase || '').replace(/\/$/, '');
            if (!base) {
                return trimmed;
            }

            return `${base}/assets/multimedia/${trimmed}`;
        },
        getInventoryVariantImage(item) {
            if (!item) {
                return '';
            }

            if (item.variant_image) {
                return this.resolveVariantImageUrl(item.variant_image);
            }

            if (!Array.isArray(this.multimedia)) {
                return '';
            }

            if (item.color_id) {
                const colorId = Number(item.color_id);
                const mediaByColor = this.multimedia.find((mediaItem) => {
                    if (!mediaItem || mediaItem.type !== 'image' || !mediaItem.path || !mediaItem.name) {
                        return false;
                    }
                    if (!mediaItem.color || !mediaItem.color.id) {
                        return false;
                    }
                    return Number(mediaItem.color.id) === colorId;
                });

                if (mediaByColor) {
                    const normalizedPath = mediaByColor.path.endsWith('/') ? mediaByColor.path : `${mediaByColor.path}/`;
                    return `${normalizedPath}${mediaByColor.name}`;
                }
            }

            // Sin imagen propia de la variante ni por color: usamos la imagen principal del artículo
            const images = this.multimedia.filter((mediaItem) => mediaItem && mediaItem.type === 'image' && mediaItem.path && mediaItem.name);
            const mainImage = images.find((mediaItem) => mediaItem.isMain) || images[0];

            if (!mainImage) {
                return '';
            }

            const normalizedPath = mainImage.path.endsWith('/') ? mainImage.path : `${mainImage.path}/`;
            return `${normalizedPath}${mainImage.name}`;
        },
        getActiveCategoryValue(value){
            this.selectedTreeCategoryData = value
            this.getSelectedCategoryParents()
        }, 
        async validate() {
            const { valid } = await this.$refs.formProduct.validate()

            if (valid) {
                this.updateProduct()
            } else {
                alert('Faltan parametros')
            }
        },
        async validateAddArticleColorSize() {
            if (!this.enabledColorVariant && !this.enabledSizeVariant) {
                this.messageErrorVariant = 'Selecciona al menos color o talla.'
                this.typeOfMessageVariant = 'error'
                setTimeout(() => (this.messageErrorVariant = ''), 10000)
                return
            }

            this.addArticleColorSize()
        },
        async validateAddInventoryProduct() {
            const { valid } = await this.$refs.formAddInventoryProduct.validate()

            if (valid) {
                this.addInventoryProduct()
            } else {
                alert('Faltan parametros')
            }
        },
        async validateUpdateProductInventory() {
            const { valid } = await this.$refs.formUpdateProductInventory.validate()

            if (valid) {
                this.updateProductInventory()
            } else {
                alert('Faltan parametros')
            } 
        },
        async validateUpdateImageProperties() {
            const { valid } = await this.$refs.formUpdateImageProperties.validate()

            if (valid) {
                this.updateImageProperties()
            } else {
                alert('Faltan parametros')
            }
        },
        resetValidation() {
            this.$refs.form.resetValidation()
        },
        getListCategory() {
            let self = this

            let apiURL = process.env.VUE_APP_URL_API_BASE + '/category/list'

            return new Promise(async (resolve, reject) => {
                let status = 'Success'
                await axios({
                    url: apiURL,
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: {},
                    responseType: 'json'
                }).then((response) => {
                    if (response.data) {
                        
                        self.treeCategoryData = this.buildTreeCategory(response.data);
                       
                        this.openedCategoryFather = [0,1]
                        status = 'Success'
                    }
                })
                resolve(status)
            })
        },
        buildTreeCategory(categories, parentId = null) {
            const tree = [];
            categories.filter(category => category.categoryFather === parentId).forEach(category => {
                const children = this.buildTreeCategory(categories, category.id);
                if (children.length) {
                    category.children = children;
                }
                tree.push(category);
                //this.toggleCategory(category)
            });
            
            return tree;
        }, 
        toggleCategory(category) {
            const index = this.openedCategoryFather.indexOf(category.id);
            if (index === -1) {
                this.openedCategoryFather.push(category.id);
            } else {
                this.openedCategoryFather.splice(index, 1);
            }
            this.openedCategoryFather = [0,1]
        },
        getSelectedCategoryParents() {
            if (this.treeCategoryData && this.selectedTreeCategoryData.length > 0) {
                const selectedCategoryId = this.selectedTreeCategoryData[0];

                // Función recursiva para buscar una categoría por su ID
                const findCategoryById = (categories, id) => {
                for (let category of categories) {
                    if (category.id === id) {
                    return category;
                    }
                    if (category.children && category.children.length > 0) {
                    const result = findCategoryById(category.children, id);
                    if (result) {
                        return result;
                    }
                    }
                }
                return null;
                };

                // Función para encontrar todos los padres de una categoría
                const findParents = (categories, id) => {
                let category = findCategoryById(categories, id);
                if (!category) {
                    return [];
                }

                const parents = [];

                while (category && category.categoryFather !== null) {
                    category = findCategoryById(categories, category.categoryFather);
                    if (category) {
                    parents.unshift(category);
                    }
                }

                return parents;
                };

                // Obtener los padres de la categoría seleccionada
                const parents = findParents(this.treeCategoryData, selectedCategoryId);

                // Buscar la categoría seleccionada para obtener su nombre
                const selectedCategory = findCategoryById(this.treeCategoryData, selectedCategoryId);

                // Concatenar los nombres de los padres y el nombre de la categoría seleccionada
                if (selectedCategory) {
                    const hierarchy = [...parents.map(parent => getMultilangText(parent.name)), getMultilangText(selectedCategory.name)].join(' > ');
                    return hierarchy;
                } else {
                    return "N/A";
                }
            }
            return "N/A";
        },
        getListColor() {
            let self = this

            let apiURL = process.env.VUE_APP_URL_API_BASE + '/color/list'

            return new Promise(async (resolve, reject) => {
                let status = 'Success'
                await axios({
                    url: apiURL,
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: {},
                    responseType: 'json'
                }).then((response) => {
                    if (response.data) {
                        self.dataColorCombo = []
                        self.dataColorCombo = response.data


                        status = 'Success'
                    }
                })
                resolve(status)
            })
        },
        getListSize() {
            let self = this

            let apiURL = process.env.VUE_APP_URL_API_BASE + '/size/list'

            return new Promise(async (resolve, reject) => {
                let status = 'Success'
                await axios({
                    url: apiURL,
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: {},
                    responseType: 'json'
                }).then((response) => {
                    if (response.data) {
                        self.dataSizeCombo = []
                        self.dataSizeCombo = response.data

                        status = 'Success'
                    }
                })
                resolve(status)
            })
        },
        getListVendor() {
            let self = this

            let apiURL = process.env.VUE_APP_URL_API_BASE + '/vendor/list'

            return new Promise(async (resolve, reject) => {
                let status = 'Success'
                await axios({
                    url: apiURL,
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: {},
                    responseType: 'json'
                }).then((response) => {
                    if (response.data) {
                        self.dataVendorCombo = []
                        self.dataVendorCombo = response.data


                        status = 'Success'
                    }
                })
                resolve(status)
            })
        },
        getArticleColorSizeGrid() {
            let self = this
            this.loadingVariant = true

            let apiURL = process.env.VUE_APP_URL_API_BASE + '/admin/article-color-size/list?idarticle=' + self.id

            return new Promise(async (resolve, reject) => {
                let status = 'Success'
                await axios({
                    url: apiURL,
                    method: 'GET',
                    responseType: 'json'
                }).then((response) => {
                    if (response.data) {
                        self.dataArticleColorSizeGrid = response.data.data || []
                        status = 'Success'
                    }
                })
                .catch((error) => {
                    self.messageErrorVariantGrid = 'Error! No se pudieron cargar las variantes.'
                    self.typeOfMessageVariantGrid = 'error'
                    setTimeout(() => (self.messageErrorVariantGrid = ''), 10000)
                    console.error(error)
                })
                self.loadingVariant = false
                resolve(status)
            })
        },
        async addArticleColorSize() {
            let newObject = {
                idarticle: this.id
            }

            if (this.enabledColorVariant && this.colorVariant) {
                newObject.color = this.colorVariant
            }
            if (this.enabledSizeVariant && this.sizeVariant) {
                newObject.size = { id: this.sizeVariant }
            }

            await axios.post(process.env.VUE_APP_URL_API_BASE + '/admin/article-color-size/create', newObject, {
                responseType: 'json'
            })
            .then((response) => {
                if (response.data.error) {
                    this.messageErrorVariant = response.data.message
                    this.typeOfMessageVariant = 'error'
                } else {
                    this.messageErrorVariant = response.data.message
                    this.typeOfMessageVariant = 'success'
                    this.enabledColorVariant = false
                    this.enabledSizeVariant = false
                    this.colorVariant = ''
                    this.sizeVariant = ''
                }
                setTimeout(() => (this.messageErrorVariant = ''), 10000)
            })
            .catch((error) => {
                this.messageErrorVariant = error?.response?.data?.message || 'Error! La variante no se ha creado.'
                this.typeOfMessageVariant = 'error'
                setTimeout(() => (this.messageErrorVariant = ''), 10000)
                console.error(error)
            })

            await this.getArticleColorSizeGrid()
        },
        openDialogDeleteArticleColorSize(item) {
            this.itemArticleColorSizeToDelete = item
            this.dialogDeleteArticleColorSize = true
        },
        async deleteArticleColorSize() {
            if (!this.itemArticleColorSizeToDelete || !this.itemArticleColorSizeToDelete.id) {
                this.dialogDeleteArticleColorSize = false
                return
            }

            await axios.post(process.env.VUE_APP_URL_API_BASE + '/admin/article-color-size/delete', { id: this.itemArticleColorSizeToDelete.id }, {
                responseType: 'json'
            })
            .then((response) => {
                if (response.data.error) {
                    this.messageErrorVariantGrid = response.data.message
                    this.typeOfMessageVariantGrid = 'error'
                } else {
                    this.messageErrorVariantGrid = response.data.message
                    this.typeOfMessageVariantGrid = 'success'
                }
                setTimeout(() => (this.messageErrorVariantGrid = ''), 10000)
            })
            .catch((error) => {
                this.messageErrorVariantGrid = error?.response?.data?.message || 'Error! La variante no se ha eliminado.'
                this.typeOfMessageVariantGrid = 'error'
                setTimeout(() => (this.messageErrorVariantGrid = ''), 10000)
                console.error(error)
            })

            this.dialogDeleteArticleColorSize = false
            this.itemArticleColorSizeToDelete = null
            await this.getArticleColorSizeGrid()
        },
        getProduct() {
            let self = this

            //Aplicamos los filtros
            let apiURL = this.apiBase+'/article/details-admin'
            return new Promise(async (resolve, reject) => {
                let status = 'Success'
                await axios({
                    url: apiURL,
                    method: 'POST',
                    data: { id: self.id },
                    responseType: 'json'
                }).then((response) => {
                    if (response.data) {
                        //Estos dos tienen multilenguaje
                        // Dependiendo del tab de lenguaje seleccionado, asignamos el contenido correspondiente

                       if(response.data.article.name){
                            self.nameEn = response.data.article.name.en
                            self.nameEs = response.data.article.name.es
                            self.nameFr = response.data.article.name.fr
                        }

                        if(response.data.article.description){
                            self.editorDataEn = response.data.article.description.en
                            self.editorDataEs = response.data.article.description.es
                            self.editorDataFr = response.data.article.description.fr
                        }

                        self.salePrice = response.data.article.salePrice
                        self.discount = response.data.article.discount
                        self.offerPrice = response.data.article.offerPrice
                        self.sku = response.data.article.sku || ''
                        self.isNew = response.data.article.isNew 
                        self.active = response.data.article.active 

                        if(response.data.article.category && response.data.article.category.id){
                            self.getActiveCategoryValue([response.data.article.category.id] )
                        }
                        
                        //FALTA IMAGENES - PATH
                        /* if (response.data.article.multimedia && response.data.article.multimedia[0]) {
                            self.srcImage = response.data.article.multimedia[0].path + response.data.article.multimedia[0].name
                            self.altImage = response.data.article.multimedia[0].alt 
                        } */
                        self.multimedia = response.data.article.multimedia
                        //Ordenamos segun OrderImage
                        self.multimedia.sort((a, b) => a.orderImage - b.orderImage);

                        status = 'Success'
                    }
                })
                resolve(status)
            })
        },
        getInventoryProductGrid({ page, itemsPerPage, sortBy, search }) {
            let self = this
            this.loading = true
           
            //Aplicamos los filtros
            let apiURL = process.env.VUE_APP_URL_API_BASE + '/inventory/gridbyarticle?page=' + page + '&limit=' + itemsPerPage + '&idarticle=' + self.id 
            if(self.filterVendorGridInventory && self.filterVendorGridInventory.name){
                apiURL = apiURL + '&vendor_name=' + self.filterVendorGridInventory.name
            }
            if(self.filterColorGridInventory && self.filterColorGridInventory.name){
                apiURL = apiURL + '&color_name=' + self.filterColorGridInventory.name
            }
            if(self.filterSizeGridInventory && self.filterSizeGridInventory.name){
                apiURL = apiURL + '&size_name=' + self.filterSizeGridInventory.name
            }
            apiURL = apiURL + '&quantity=' + self.filterQuantityGridInventory 
            apiURL = apiURL + '&stock=' + self.filterStockGridInventory 
            apiURL = apiURL + '&description=' + self.filterDescriptionGridInventory
            

            //Aplicamos el orden
            if (sortBy && sortBy[0]) {
                apiURL = apiURL + '&sort=' + sortBy[0].key + '&order=' + sortBy[0].order
            }

            return new Promise(async (resolve, reject) => {
                let status = 'Success'
                await axios({
                    url: apiURL,
                    method: 'GET',
                    data: {},
                    responseType: 'json'
                }).then((response) => {
                    if (response.data) {

                        self.dataInventoryProductGrid = []
                        self.dataInventoryProductGrid = response.data.data

                        self.pagination.from = response.data.from
                        self.pagination.to = response.data.to
                        self.pagination.total = response.data.total
                        self.pagination.current = response.data.current_page
                        self.pagination.lastPage = response.data.last_page

                        
                        this.loading = false
                        status = 'Success'
                    }
                })
                resolve(status)
            })
        },
        openDialogUpdateGridInventory(item){
            this.dialogEditGridInventory = true

            this.updateIdInventoryArticleInventory = ''
            this.updateArticlecolorsizeidArticleInventory = ''
            this.updateVendorArticleInventory = ''
            this.updateColorArticleInventory = ''
            this.updateSizeArticleInventory = ''
            this.updateQuantityArticleInventory = ''
            this.updateStockArticleInventory = ''
            this.updateDescriptionArticleInventory = ''

            this.updateIdInventoryArticleInventory= item.id
            this.updateArticlecolorsizeidArticleInventory= item.article_color_size_id
            if(item.vendor_id)  this.updateVendorArticleInventory = { id: item.vendor_id , name: item.vendor_name}
            if(item.color_id) {
                this.updateColorArticleInventory = { id: item.color_id , name: item.color_name, hexadecimalCode: item.color_hexadecimal}
            }
            if(item.size_id) this.updateSizeArticleInventory = { id: item.size_id , name: item.size_name}
            this.updateQuantityArticleInventory = item.quantity
            this.updateStockArticleInventory = item.stock
            this.updateDescriptionArticleInventory = item.description

        },
        openDialogUpdateImageProperties(item){
            this.dialogUpdateImageProperties = true

            this.updateIdImageProperties = item.id
            this.updateTypeImageProperties = item.type
            this.enabledColorImageProperties = false

            this.updateColorImageProperties = ''
            if(item && item.color && item.color.id) {
                this.enabledColorImageProperties = true
                this.updateColorImageProperties = { id: item.color.id , name: item.color.name}
            }

            this.updateAltImageProperties = ''
            if(item && item.alt) {
                this.updateAltImageProperties = item.alt
            }
            
            this.updateIsFrontImageImageProperties = item.isFrontImage
            this.updateIsBackImageImageProperties = item.isBackImage
            this.isMainImageProperties = item.isMain

            // De momento no se podra modificar via manual
            this.orderImageProperties = item.orderImage

            
        },          
        updateProduct() {
            let newObject = {
                idarticle: this.id,
                name: { en: this.nameEn, es: this.nameEs, fr: this.nameFr },                     //MultiIdioma
                description: { en: this.editorDataEn, es: this.editorDataEs, fr: this.editorDataFr },  //MultiIdioma
                saleprice: this.salePrice,
                discount: this.discount,
                offerprice: this.offerPrice,
                isnew: this.isNew,
                active: this.active
            }
            if (this.selectedTreeCategoryData.length > 0) {
                newObject.category = this.selectedTreeCategoryData[0];
            }

            axios.post(process.env.VUE_APP_URL_API_BASE + '/admin/article/update', newObject, {
                responseType: 'json' // Especifica el tipo de respuesta
            })
            .then((response) => {
                if (response.data.error) {
                    this.messageError = response.data.message
                    this.typeOfMessage = 'error'
                } else {
                    this.messageError = response.data.message
                    this.typeOfMessage = 'success'
                }
                setTimeout(() => (this.messageError = ''), 10000)
            })
            .catch((error) => {
                this.messageError = 'Error! El articulo no se ha modificado.'
                this.typeOfMessage = 'error'
                setTimeout(() => (this.messageError = ''), 10000)
                console.error(error)
            })
        },
        async addInventoryProduct(){
            let newObject = {
                idarticle: this.id,
                useradmin: this.getUser.id,
                vendor: this.vendorInventory,
                articlecolorsizeid: this.articleColorSizeInventory && this.articleColorSizeInventory.id,
                quantity: this.quantityInventory,
                stock: this.stockInventory,
                description: this.descriptionInventory
            }

            await axios.post(process.env.VUE_APP_URL_API_BASE + '/admin/inventory/create', newObject, {
                responseType: 'json' // Especifica el tipo de respuesta
            })
            .then((response) => {
                if (response.data.error) {
                    this.messageErrorInventory = response.data.message
                    this.typeOfMessageInventory = 'error'
                } else {
                    this.messageErrorInventory = response.data.message
                    this.typeOfMessageInventory = 'success'
                    this.articleColorSizeInventory = ''
                }
                setTimeout(() => (this.messageErrorInventory = ''), 10000)

            })
            .catch((error) => {
                this.messageErrorInventory = error?.response?.data?.message || 'Error! El inventario no se ha modificado.'
                this.typeOfMessageInventory = 'error'
                setTimeout(() => (this.messageErrorInventory = ''), 10000)
                console.error(error)
            })

            // Vuelve a cargar los grids (inventario y variantes, por el stock agregado)
            const { current, itemsPerPage, sortBy, search } = this.pagination;
            await this.getInventoryProductGrid({ page: current, itemsPerPage, sortBy, search });
            await this.getArticleColorSizeGrid();
        },
        async updateImageOrder(){

            // Los videos nunca deben marcarse como imagen principal/frontal/trasera:
            // esos flags alimentan la miniatura del producto y el swatch de color.
            let imageRank = 0;
            this.multimedia.forEach((image, index) => {
                image.orderImage = index + 1;

                if (image.type === 'video') {
                    image.isMain = false;
                    image.isFrontImage = false;
                    image.isBackImage = false;
                    return;
                }

                imageRank++;
                image.isMain = imageRank === 1;
                image.isFrontImage = imageRank === 1;
                image.isBackImage = imageRank === 2;
            });
            let newObject = {
                idarticle: this.id,
                // Solo enviamos multimedia ya persistida: los archivos recién soltados
                // (sin id todavía) no existen en BD y romperían el lookup del backend.
                multimedia: this.multimedia.filter((image) => !!image.id)
            }
            await axios.post(process.env.VUE_APP_URL_API_BASE + '/admin/multimedia/updateorder', newObject, {
                responseType: 'json' // Especifica el tipo de respuesta
            })
            .then((response) => {
                if (response.data.error) {
                    this.messageError = response.data.message
                    this.typeOfMessage = 'error'
                } else {
                    this.messageError = response.data.message
                    this.typeOfMessage = 'success'
                }
                setTimeout(() => (this.messageError = ''), 10000)
                
            })
            .catch((error) => {
                this.messageError = 'Error! El inventario no se ha modificado.'
                this.typeOfMessage = 'error'
                setTimeout(() => (this.messageError = ''), 10000)
                console.error(error)
            }) 


            //Vuelve a cargar las imagenes
            this.getProduct() 
        },
        async updateImageProperties(){

            let newObject = {
                id: this.updateIdImageProperties,
                idarticle: this.id,
                alt: this.updateAltImageProperties,
                isfrontimage: this.updateIsFrontImageImageProperties,
                isbackimage: this.updateIsBackImageImageProperties 
            }
            
            if (this.enabledColorImageProperties && this.updateColorImageProperties ){
                newObject.color = this.updateColorImageProperties
            }

            await axios.post(process.env.VUE_APP_URL_API_BASE + '/admin/multimedia/updateproperties', newObject, {
                responseType: 'json' // Especifica el tipo de respuesta
            })
            .then((response) => {
                if (response.data.error) {
                    this.messageError = response.data.message
                    this.typeOfMessage = 'error'
                } else {
                    this.messageError = response.data.message
                    this.typeOfMessage = 'success'
                }
                setTimeout(() => (this.messageError = ''), 10000)
                
            })
            .catch((error) => {
                this.messageError = 'Error! El inventario no se ha modificado.'
                this.typeOfMessage = 'error'
                setTimeout(() => (this.messageError = ''), 10000)
                console.error(error)
            }) 

            this.dialogUpdateImageProperties = false

            //Vuelve a cargar las imagenes
            this.getProduct() 
        },
        async updateProductInventory(){
            // Solo modifica vendor/cantidad/stock/descripción de una fila de Inventory ya
            // existente. La variante (ArticleColorSize) de la fila es fija y se gestiona
            // aparte en el panel "Variants (Colors/Sizes)".
            let newObject = {
                idinventory: this.updateIdInventoryArticleInventory,
                idarticle: this.id,
                useradmin: this.getUser.id,
                vendor: this.updateVendorArticleInventory,
                quantity: this.updateQuantityArticleInventory,
                stock: this.updateStockArticleInventory,
                description: this.updateDescriptionArticleInventory
            }

            await axios.post(process.env.VUE_APP_URL_API_BASE + '/admin/inventory/update', newObject, {
                responseType: 'json' // Especifica el tipo de respuesta
            })
            .then((response) => {
                if (response.data.error) {
                    this.messageError = response.data.message
                    this.typeOfMessage = 'error'
                } else {
                    this.messageError = response.data.message
                    this.typeOfMessage = 'success'
                }
                setTimeout(() => (this.messageError = ''), 10000)

            })
            .catch((error) => {
                this.messageError = error?.response?.data?.message || 'Error! El inventario no se ha modificado.'
                this.typeOfMessage = 'error'
                setTimeout(() => (this.messageError = ''), 10000)
                console.error(error)
            })

            this.dialogEditGridInventory = false
            // Vuelve a cargar los grids (inventario y variantes, por el stock agregado)
            const { current, itemsPerPage, sortBy, search } = this.pagination;
            await this.getInventoryProductGrid({ page: current, itemsPerPage, sortBy, search });
            await this.getArticleColorSizeGrid();
        },
        openDialogDeleteGridInventory(item) {
            this.itemInventoryToDelete = item;
            this.dialogDeleteGridInventory = true;
        },
        getSelectedArticleCommentStatus(item) {
            const status = this.itemsArticleCommentStatus.find(status => status.id == item.status_id)
            return status ? status : this.itemsArticleCommentStatus.find(status => status.name == 'Pendiente')?.name
        },
        setStatusSavingComment(id, saving) {
            this.statusSavingCommentsById = {
                ...this.statusSavingCommentsById,
                [id]: saving
            }
        },
        setStatusSavedComment(id, saved) {
            this.statusSavedCommentsById = {
                ...this.statusSavedCommentsById,
                [id]: saved
            }
        },
        isStatusSavingComment(item) {
            return !!this.statusSavingCommentsById[item.id]
        },
        isStatusSavedComment(item) {
            return !!this.statusSavedCommentsById[item.id]
        },
        async handleArticleCommentStatusChange(newStatus, item) {
            this.setStatusSavedComment(item.id, false)
            this.setStatusSavingComment(item.id, true)
            try {
                await articleCommmentsStatusChangeService(item.id, newStatus.id)
                item.status_id = newStatus.id
                item.status_name = newStatus.name
                this.setStatusSavedComment(item.id, true)
                setTimeout(() => this.setStatusSavedComment(item.id, false), 1500)
            } catch (error) {
                this.messageError = 'Error! No se pudo guardar el estado del comentario.'
                this.typeOfMessage = 'error'
                setTimeout(() => (this.messageError = ''), 6000)
            } finally {
                this.setStatusSavingComment(item.id, false)
            }
        },
        getFormatUpdatedAtComment(updatedAt) {
            if (!updatedAt) return '-'

            let dateValue = updatedAt

            if (typeof updatedAt === 'object') {
                if (typeof updatedAt.timestamp === 'number') {
                    dateValue = updatedAt.timestamp * 1000
                } else if (updatedAt.date) {
                    dateValue = updatedAt.date
                }
            }

            const date = new Date(dateValue)
            if (Number.isNaN(date.getTime())) return '-'

            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            const hours = String(date.getHours()).padStart(2, '0')
            const minutes = String(date.getMinutes()).padStart(2, '0')
            const seconds = String(date.getSeconds()).padStart(2, '0')

            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
        },
        editProductComment(item) {
            this.$router.push({ name: 'edit_product_comment', params: { id: item.id } })
        },
        openDialogDeleteComment(item) {
            this.itemProductCommentToDelete = item
            this.dialogDeleteProductComment = true
        },
        async deleteProductComment() {
            if (!this.itemProductCommentToDelete || !this.itemProductCommentToDelete.id) {
                this.dialogDeleteProductComment = false
                return
            }

            await deleteArticleCommentService(this.itemProductCommentToDelete.id)
            this.dialogDeleteProductComment = false
            this.itemProductCommentToDelete = null
            await this.getProductCommentsGrid({ page: this.paginationComments.current, itemsPerPage: this.itemsPerPageComments })
        },
        async createProductComment() {
            this.newCommentError = ''

            const text = (this.newCommentText || '').trim()
            if (text === '') {
                this.newCommentError = 'El comentario no puede estar vacío.'
                return
            }
            if (!this.newCommentAssessment || this.newCommentAssessment < 1) {
                this.newCommentError = 'Selecciona una valoración de 1 a 5.'
                return
            }
            if (this.newCommentImages.length > 5) {
                this.newCommentError = 'Máximo 5 imágenes por comentario.'
                return
            }
            if (this.newCommentVideos.length > 2) {
                this.newCommentError = 'Máximo 2 vídeos por comentario.'
                return
            }

            const formData = new FormData()
            formData.append('article_id', this.id)
            formData.append('comment', text)
            formData.append('assessment', this.newCommentAssessment)
            this.newCommentImages.forEach((file, index) => {
                formData.append(`images[${index}]`, file)
            })
            this.newCommentVideos.forEach((file, index) => {
                formData.append(`videos[${index}]`, file)
            })

            this.savingNewComment = true
            try {
                const response = await createArticleCommentService(formData)
                if (response.error) {
                    this.newCommentError = response.message || 'Error! No se pudo crear el comentario.'
                } else {
                    this.newCommentText = ''
                    this.newCommentAssessment = 0
                    this.newCommentImages = []
                    this.newCommentVideos = []
                    this.messageError = response.message || 'Comentario creado correctamente.'
                    this.typeOfMessage = 'success'
                    setTimeout(() => (this.messageError = ''), 6000)
                    await this.getProductCommentsGrid({ page: this.paginationComments.current, itemsPerPage: this.itemsPerPageComments })
                }
            } catch (error) {
                this.newCommentError = 'Error! No se pudo crear el comentario.'
            } finally {
                this.savingNewComment = false
            }
        },
        async getProductCommentsGrid({ page = 1, itemsPerPage = 10, sortBy = [] } = {}) {
            this.loadingComments = true
            try {
                const data = await getGridArticleCommentService({
                    page,
                    itemsPerPage,
                    sortBy,
                    article_id: this.id,
                    user_name: this.filterUserNameComment,
                    comment: this.filterTextComment,
                    assessment: this.filterAssessmentComment,
                    updated_at: this.filterUpdatedAtComment
                })

                this.dataCommentsProductGrid = data.data || []
                this.paginationComments.from = data.from
                this.paginationComments.to = data.to
                this.paginationComments.total = data.total
                this.paginationComments.current = data.current_page
                this.paginationComments.lastPage = data.last_page
            } catch (error) {
                console.error('Error fetching comments grid by product:', error)
            } finally {
                this.loadingComments = false
            }
        },
        async deleteProductInventory(){

            let newObject = {
                idinventory: this.itemInventoryToDelete.id
            }

            this.dialogDeleteGridInventory = false;
            this.itemInventoryToDelete = null;

            await axios.post(process.env.VUE_APP_URL_API_BASE + '/admin/inventory/delete', newObject, {
                responseType: 'json' // Especifica el tipo de respuesta
            })
            .then((response) => {
                if (response.data.error) {
                    this.messageError = response.data.message
                    this.typeOfMessage = 'error'
                } else {
                    this.messageError = response.data.message
                    this.typeOfMessage = 'success'
                }
                setTimeout(() => (this.messageError = ''), 10000)
            })
            .catch((error) => {
                this.messageError = 'Error! El inventario no se ha modificado.'
                this.typeOfMessage = 'error'
                setTimeout(() => (this.messageError = ''), 10000)
                console.error(error)
            }) 

            // Vuelve a cargar los grids (inventario y variantes, por el stock agregado)
            const { current, itemsPerPage, sortBy, search } = this.pagination;
            await this.getInventoryProductGrid({ page: current, itemsPerPage, sortBy, search });
            await this.getArticleColorSizeGrid();


        },
       
        //Dropzone Functions
        dragOver(event) {
            event.preventDefault();
            if (this.uploadingMultimedia) {
                return;
            }
            this.highlightDropzone(true);
        },
        dragLeave(event) {
            event.preventDefault();
            this.highlightDropzone(false);
        },
        drop(event) {
            event.preventDefault();
            this.highlightDropzone(false);
            if (this.uploadingMultimedia) {
                return; // Ya hay una subida en curso, ignoramos el nuevo drop
            }
            const fileList = event.dataTransfer.files;
            this.uploadFileList(fileList);
        },
        highlightDropzone(highlight) {
            const dropzone = this.$refs.fileInput.parentNode;
            dropzone.classList.toggle('highlight', highlight);
        },
        handleFileInput(event) {
            const fileList = event.target.files;
            if (!this.uploadFileList(fileList)) {
                event.target.value = ''; // Limpiar el input si algún archivo es demasiado grande
            }
        },
        uploadFileList(fileList) {
            if (this.uploadingMultimedia) {
                return false; // Ya hay una subida en curso
            }

            const maxSize = 60 * 1024 * 1024; // 60 MB

            // Verificar el tamaño de cada archivo
            for (const file of fileList) {
                if (file.size > maxSize) {
                    alert(`El archivo ${file.name} es demasiado grande. El tamaño máximo permitido es 60 MB.`);
                    return false; // Detener el proceso si un archivo es demasiado grande
                }
            }

            this.selectedImages = []; // Limpiar las imágenes seleccionadas antes de procesar
            this.uploadingMultimedia = true;
            this.uploadProgress = 0;

            // Procesa los archivos y espera a que todos se lean
            this.processFiles(fileList).then(() => {
                // Llama a createThisImage solo después de que todos los archivos se hayan procesado
                this.createThisImage();
            });

            return true;
        },
        processFiles(fileList) {
            const promises = [];

            for (let i = 0; i < fileList.length; i++) {
                const file = fileList[i];
                this.selectedImages.push(file);

                if (file.type.match('image.*')) {
                    const reader = new FileReader();
                    const promise = new Promise((resolve) => {
                        reader.onload = (event) => {
                            const fileData = {
                                name: file.name,
                                url: event.target.result,
                                codi: "codificada",
                                type: 'image'
                            };
                            this.multimedia.push(fileData);
                            resolve();
                        };
                    });

                    reader.readAsDataURL(file);
                    promises.push(promise);
                } else if (file.type.match('video.*')) {
                    // Los vídeos pueden pesar decenas de MB: leerlos como base64 (FileReader)
                    // bloquea la pestaña. Un object URL es instantáneo y no copia el archivo en memoria.
                    const fileData = {
                        name: file.name,
                        url: URL.createObjectURL(file),
                        codi: "codificada",
                        type: 'video'
                    };
                    this.multimedia.push(fileData);
                    promises.push(Promise.resolve());
                }
            }

            return Promise.all(promises);
        },
        processFiles2(fileList) {
            const promises = []; // Array para almacenar las promesas

            for (let i = 0; i < fileList.length; i++) {
                const file = fileList[i];
                this.selectedImages.push(file);

                if (file.type.match('image.*')) {
                    const reader = new FileReader();
                    const promise = new Promise((resolve) => {
                        reader.onload = (event) => {
                            const fileData = {
                                name: file.name,
                                url: event.target.result,
                                codi: "codificada",
                                type: 'image' // Agregar tipo de archivo
                            };
                            this.multimedia.push(fileData);
                            resolve(); // Resuelve la promesa al finalizar la carga
                        };
                    });

                    reader.readAsDataURL(file); // Inicia la lectura del archivo
                    promises.push(promise); // Agrega la promesa al array
                } else if (file.type.match('video.*')) {
                    const fileData = {
                        name: file.name,
                        url: URL.createObjectURL(file),
                        codi: "codificada",
                        type: 'video' // Agregar tipo de archivo
                    };
                    this.multimedia.push(fileData);
                    promises.push(Promise.resolve()); // Agrega una promesa resuelta para mantener la consistencia
                }
            }

            return Promise.all(promises); // Retorna una promesa que se resuelve cuando todas se han completado
        },
        createThisImage() {
            let newObject = {
                idarticle: this.id,
            }

            const formData = new FormData();
            formData.append('form', JSON.stringify(newObject));

            // Agregar los archivos al objeto FormData
            this.selectedImages.forEach((image, index) => {
                formData.append(`files[${index}]`, image); // Aquí se agregan los archivos crudos
            });


            axios.post(process.env.VUE_APP_URL_API_BASE + '/admin/multimedia/create', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                responseType: 'json', // Especifica el tipo de respuesta
                onUploadProgress: (progressEvent) => {
                    if (progressEvent.total) {
                        this.uploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    }
                }
            })
            .then((response) => {
                if (response.data.error) {
                    this.messageError = response.data.message
                    this.typeOfMessage = 'error'
                } else {
                    this.messageError = response.data.message
                    this.typeOfMessage = 'success'
                }
                //Vuelve a cargar las imagenes
                this.getProduct()
                setTimeout(() => (this.messageError = ''), 10000)
            })
            .catch((error) => {
                this.messageError = 'Error! El producto no se ha modificado.'
                this.typeOfMessage = 'error'
                setTimeout(() => (this.messageError = ''), 10000)
                console.error(error)
            })
            .finally(() => {
                this.uploadingMultimedia = false;
                this.uploadProgress = 0;
            })
        },
        createThisImage2() {
            let newObject = {
                idarticle: this.id,
            }

            const formData = new FormData();
            formData.append('form', JSON.stringify(newObject));

            // Agregar los archivos al objeto FormData
            this.selectedImages.forEach((image, index) => {
                formData.append(`images[${index}]`, image); // Aquí se agregan los archivos crudos
            });

            // Agregar los archivos al objeto FormData
            //formData.append('createThisImage multimedia', JSON.stringify(this.multimedia));

            formData.append('createThisImage multimedia', this.multimedia);

            /* axios({
                url: process.env.VUE_APP_URL_API_BASE + '/blog/update',
                method: 'POST',
                data: formData,
                responseType: 'json',
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }) */
            axios.post(process.env.VUE_APP_URL_API_BASE + '/admin/multimedia/create', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                responseType: 'json' // Especifica el tipo de respuesta
            })
            .then((response) => {
                if (response.data.error) {
                    this.messageError = response.data.message
                    this.typeOfMessage = 'error'
                } else {
                    this.messageError = response.data.message
                    this.typeOfMessage = 'success'
                }
                //Vuelve a cargar las imagenes
                this.getProduct() 
                setTimeout(() => (this.messageError = ''), 10000)
            })
            .catch((error) => {
                this.messageError = 'Error! El producto no se ha modificado.'
                this.typeOfMessage = 'error'
                setTimeout(() => (this.messageError = ''), 10000)
                console.error(error)
            })

        },

        async deleteThisImage(index, id) {
            if (!confirm('¿Seguro que quieres eliminar este archivo? Esta acción no se puede deshacer.')) {
                return;
            }

            let self = this;
            // Borramos en multimedia y en la base de datos
            self.multimedia.splice(index, 1);
            
            let newObject = {
                id: id
            }

            await axios.post(process.env.VUE_APP_URL_API_BASE + '/admin/multimedia/delete', newObject, {
                responseType: 'json' // Especifica el tipo de respuesta
            })
            .then((response) => {
                if (response.data.error) {
                    this.messageError = response.data.message
                    this.typeOfMessage = 'error'
                } else {
                    this.messageError = response.data.message
                    this.typeOfMessage = 'success'
                }
                setTimeout(() => (this.messageError = ''), 10000)
            })
            .catch((error) => {
                this.messageError = 'Error! La imagen se ha eliminado.'
                this.typeOfMessage = 'error'
                setTimeout(() => (this.messageError = ''), 10000)
                console.error(error)
            }) 

            //Vuelve a cargar las imagenes
            this.getProduct() 

        },
        moveImage(indice, id, direction) {
            // Verificar si el índice está dentro de los límites del array
            if (indice < 0 || indice >= this.multimedia.length) {
                return;
            }

            // Si la dirección es "izquierda"
            if (direction === "left") {
                // Si el índice es 0, no se puede mover más a la izquierda
                if (indice === 0) {
                    return;
                }
                // Intercambiar el elemento con el que está a su izquierda
                [this.multimedia[indice], this.multimedia[indice - 1]] = [this.multimedia[indice - 1], this.multimedia[indice]];

                this.updateImageOrder()
            }
            // Si la dirección es "derecha"
            else if (direction === "right") {
                // Si el índice es el último, no se puede mover más a la derecha
                if (indice === this.multimedia.length - 1) {
                    return;
                }
                // Intercambiar el elemento con el que está a su derecha
                [this.multimedia[indice], this.multimedia[indice + 1]] = [this.multimedia[indice + 1], this.multimedia[indice]];

                this.updateImageOrder()
            } else {
                return;
            }
        }
    },
    async beforeMount() {
        this.id = this.$route.params.id;
        await this.getListColor();
        await this.getListCategory();
        await this.getProduct();
        await this.getListSize();
        await this.getListVendor();
        await this.getArticleColorSizeGrid();
        this.itemsArticleCommentStatus = await getArticleCommmentsStatusListService();
        await this.getProductCommentsGrid({ page: 1, itemsPerPage: this.itemsPerPageComments });
        

        
       // await this.getInventoryProductGrid();
       

    }
}
</script>

<style lang="scss" scoped>
.dropzone {
    border: 2px dashed #ccc;
    cursor: pointer;
}

.dropzone.highlight {
    border-color: #888;
}

.dropzone-disabled {
    pointer-events: none;
    opacity: 0.7;
}

.dropzone-overlay {
    position: absolute;
    inset: 0;
    z-index: 200;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.55);
    color: white;
    font-size: 14px;
    border-radius: 4px;
}

.image-preview {
    width: 24%; 
    height: auto;
}

.image-name {
    display: block;
    margin-top: 5px;
}

.new-comment-form :deep(.v-card-text) {
    padding-top: 0;
}



.buttons-image-dropzone {
    position: absolute;
    right: 2px;
    width: 25px;
    border: 1px solid gray;
    background: white;
    padding: 3px;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;

    &:disabled {
        opacity: 0.4;
        cursor: not-allowed;
    }

    &.isMainImage-button {
        top: 2px;
        left: 2px;
        background: green;
    }

    &.isBackImage-button {
        top: 2px;
        left: 2px;
        background: red;
    }

    &.left-button {
        top: 29px;
        &:hover {
            background: gray;
            color: white;
        }
    }

    &.right-button {
        top: 56px;
        &:hover {
            background: gray;
            color: white;
        }
    }

    &.edit-image-button {
        top: 83px;
        &:hover {
            background: gray;
            color: white;
            
        }
    }

    &.delete-button {
        top: 2px;

        &:hover {
            background: red;
            border: 1px solid red;
            color: white;
        }
    }
}

.video-type-badge {
    position: absolute;
    bottom: 4px;
    left: 4px;
    z-index: 100;
    display: flex;
    align-items: center;
    gap: 3px;
    padding: 2px 6px;
    border-radius: 4px;
    background: rgba(0, 0, 0, 0.65);
    color: white;
    font-size: 11px;
    line-height: 1;
    pointer-events: none;
}

.inventory-variant-thumb {
    width: 44px;
    height: 44px;
    margin: 0 auto;
}
</style>
